import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const ContactUs = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="text-center">
      <bootstrap.Container className="pt-5">
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="">{t("contact.header")}</h2>
            <p className="lead pt-1">{t("contact.subHeader")}</p>
            <address>
              <p className="lead fw-bold">{t("contact.phone")}</p>
            </address>
            <address>
              <p className="lead fw-bold">{t("contact.hours")}</p>
              <p className="lead">{t("contact.monday")}</p>
              <p className="lead">{t("contact.tuesday")}</p>
              <p className="lead">{t("contact.wednesday")}</p>
              <p className="lead">{t("contact.thursday")}</p>
              <p className="lead">{t("contact.friday")}</p>
            </address>
            <address>
              <p className="lead fw-bold">{t("contact.email")}</p>
            </address>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
